document.addEventListener('turbolinks:load', function() {
  gtag('config', 'UA-124170088-3')
});